import { Link, useLocation } from "react-router-dom";
import { LANG_CODES, LANGS, localizePath, rememberLang, useI18n } from ".";
import { track } from "../metrics/track";

// SR / EN / RU links to the same page in another language. Real links (not buttons),
// so crawlers can discover every language version.
export default function LanguageSwitcher({ className = "" }) {
  const { lang, basePath, t } = useI18n();
  const { search, hash } = useLocation();

  return (
    <nav className={`lang-switch ${className}`} aria-label={t("lang.label")}>
      {LANG_CODES.map((code) => {
        const active = code === lang;
        return (
          <Link
            key={code}
            to={`${localizePath(basePath, code)}${search}${hash}`}
            hrefLang={LANGS[code].hreflang}
            lang={LANGS[code].htmlLang}
            className={`lang-switch-link ${active ? "is-active" : ""}`}
            aria-current={active ? "true" : undefined}
            aria-label={t("lang.switchTo", { name: LANGS[code].name })}
            onClick={() => {
              rememberLang(code);
              if (!active) track("lang_switch", { label: code });
            }}
          >
            {LANGS[code].label}
          </Link>
        );
      })}
    </nav>
  );
}
